import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { LoadingButton } from 'base-ui'

import {
  useApiSwrReavailabilityNotificationGetSubscriptionStatus,
  useApiSwrReavailabilityNotificationSubscribeUpidMutation,
} from '../../../../../../user-data'
import { useProductPageContext } from '../../../../productPageContext'

export const ProductOutOfStockSendReminderSubscribeButton: FC = () => {
  const { product } = useProductPageContext()

  const subscriptionStatusSwr =
    useApiSwrReavailabilityNotificationGetSubscriptionStatus({
      productId: product.upid,
    })

  const subscribeMutation =
    useApiSwrReavailabilityNotificationSubscribeUpidMutation()

  const alreadySubscribed =
    !subscriptionStatusSwr.isLoading &&
    subscriptionStatusSwr.data?.isCustomerSubscribed

  const notSubscribed = !alreadySubscribed

  const showLoadingIndicator =
    subscriptionStatusSwr.isLoading ||
    subscribeMutation.isMutating ||
    subscriptionStatusSwr.error

  const canSubmit = notSubscribed && !showLoadingIndicator

  const submit = async (): Promise<void> => {
    await subscribeMutation.trigger({ productId: product.upid })
    await subscriptionStatusSwr.mutate()
  }

  return (
    <LoadingButton
      // `whitespace-normal` is used because German text doesn't fit button on tablet
      className="grow whitespace-normal"
      disabled={alreadySubscribed}
      loading={Boolean(showLoadingIndicator)}
      onClick={() => {
        if (canSubmit) {
          void submit()
        }
      }}
      type="button"
    >
      {notSubscribed ? (
        <FormattedMessage id="backInStock.button.activate" />
      ) : (
        <FormattedMessage id="backInStock.label.active" />
      )}
    </LoadingButton>
  )
}
